export type DescriptionPrefixPattern = {
  id: string;
  regex: RegExp;
  prefixGroup: number;
  merchantGroup: number;
  dateGroup?: number;
  /** Used instead of the merchant when the merchant is a payment processor
   * (the Swish message usually names the real shop) */
  messageGroup?: number;
};

/**
 * Bank reference numbers that Nordea/Enable Banking put in front of the text,
 * e.g. "1833107993840774 Swish betalning …" or "000028499 Autogiro …".
 * Some arrive with a leading C1 control character (raw or JSON-escaped).
 */
export const LEADING_REFERENCE = /^(?:\\u00[89][0-9a-f]|[\u0080-\u009f])?\d{6,}\s+/i;

/** Swish payees that only process the payment; the message names the shop */
export const PAYMENT_PROCESSORS = /^(?:adyen n\.v\.|processed by stripe|stripe|nets|bambora|zettle)(?:\s|$)/i;

export const DESCRIPTION_PREFIX_PATTERNS: DescriptionPrefixPattern[] = [
  {
    id: 'reservation-kortkop',
    regex: /^(reservation\s+kortköp)\s+(?:(\d{6})\s+)?(.+)$/i,
    prefixGroup: 1,
    dateGroup: 2,
    merchantGroup: 3,
  },
  {
    id: 'kortkop',
    regex: /^(kortköp)\s+(?:(\d{6})\s+)?(.+)$/i,
    prefixGroup: 1,
    dateGroup: 2,
    merchantGroup: 3,
  },
  {
    // The payer's message may come first: "Mullvad VPN 1 month Swish betalning MULLVAD VPN AB"
    id: 'swish',
    regex: /^(?:(.+?)\s+)?(swish\s+(?:betalning|inbetalning|återbetalning))\s+(.+)$/i,
    prefixGroup: 2,
    merchantGroup: 3,
    messageGroup: 1,
  },
  {
    id: 'open-banking-bg',
    regex: /^(open banking\s+bg\s+[\d-]+)\s+(.+)$/i,
    prefixGroup: 1,
    merchantGroup: 2,
  },
  {
    id: 'betalning-bg',
    regex: /^(betalning\s+bg\s+[\d-]+)\s+(.+)$/i,
    prefixGroup: 1,
    merchantGroup: 2,
  },
  {
    id: 'betalning-pg',
    regex: /^(betalning\s+pg\s+[\d-]+)\s+(.+)$/i,
    prefixGroup: 1,
    merchantGroup: 2,
  },
  {
    id: 'bg',
    regex: /^(bg\s+[\d-]+)\s+(.+)$/i,
    prefixGroup: 1,
    merchantGroup: 2,
  },
  {
    id: 'autogiro',
    regex: /^(autogiro)\s+(.+)$/i,
    prefixGroup: 1,
    merchantGroup: 2,
  },
  {
    id: 'efaktura',
    regex: /^(e-faktura)\s+(.+)$/i,
    prefixGroup: 1,
    merchantGroup: 2,
  },
  {
    id: 'transfer',
    regex: /^((?:överföring|overföring|overforing))\s+(.+)$/i,
    prefixGroup: 1,
    merchantGroup: 2,
  },
];
